import React, { Component } from 'react'
import { Pagination, Row, Button, Spin, Modal, Col } from 'antd'
import { app, api, config } from "../../../app"

class TeamHonorWall extends Component {
    constructor (props) {
        super(props)
        this.state = {
            dataList: [],
            data_loading: true,
            page: 1,
            total: 0,
            reqParam: props.param,
            enter: props.enter,
            teamname: "正在加载 ... "
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { reqParam, enter } = this.state, url = '', params = { page }
        switch (enter) {
            case 'province':
                params.province = reqParam
                url = api.HProvinceLists
                break
            case 'team':
                params.teamno = reqParam
                url = api.HTeamLists
                break
            case 'player':
                params.indexno = reqParam
                url = api.HUserLists
                break
            default:
                app.alert('信息不存在')
                app.backPage(this)
                return
        }
        let { flag, data, msg, count, teamname } = await app.post(url, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            this.setData({ teamname, data_loading: false, dataList: data, total: parseInt(count || 0) })
        }
    }
    /**
     * 荣誉墙点击
     * @param honor
     */
    handleHonorClick = async (honor) => {
        Modal.info({
            title: '荣誉详情',
            okText: '确定',
            centered: true,
            width: '50vw',
            content: (
                <div style={{ padding: '20px 0' }}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{textAlign: 'right'}}>荣誉图片：</Col>
                        <Col span={14} offset={1}>
                            <div style={{ height: 120 }}>
                                <img style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
                                     src={config.imgUrl + honor.img} alt="" title={honor.name}/>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{textAlign: 'right'}}>荣誉名称：</Col>
                        <Col span={14} offset={1}>{honor.name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{textAlign: 'right'}}>荣誉类型：</Col>
                        <Col span={14} offset={1}>{honor.type_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{textAlign: 'right'}}>荣誉等级：</Col>
                        <Col span={14} offset={1}>{honor.category_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{textAlign: 'right'}}>获奖时间：</Col>
                        <Col span={14} offset={1}>{honor.date}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{textAlign: 'right'}}>备注信息：</Col>
                        <Col span={14} offset={1}><span>{honor.remark || ' - '}</span></Col>
                    </Row>
                </div>
            )
        })
    }


    render () {
        let { data_loading, teamname, dataList, total, page } = this.state
        return (
            <div className="equipments-page">
                <Row className="equipments-title" type="flex" justify="space-between">
                    <span>{teamname} 荣誉墙</span>
                    <Button type="primary" onClick={() => this.props.onBack()}>返回</Button>
                </Row>
                <div className="mp-content">
                    <Row className="no-data" type="flex" justify="center" align="middle" hidden={!data_loading}><Spin/></Row>
                    <div className="mp-list" hidden={data_loading}>
                        {
                            dataList.map((item, i) => {
                                return (
                                    <div className="dl-img-item" title={item.name} key={i} onClick={() => this.handleHonorClick(item)}>
                                        <div className="dii-img"><img src={config.imgUrl + item.img}/></div>
                                        <div className="dii-name">
                                            <div>{item.name}</div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <Pagination
                        total={total}
                        current={page}
                        pageSize={20}
                        size="small"
                        showTotal={(total) => `总数量：${total}`}
                        onChange={this.handleData}
                        style={{ textAlign: "center", padding: 20 }}
                    />
                </div>
            </div>
        )
    }
}

export default TeamHonorWall



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamMore/TeamHonorWall.jsx